<template>
  <div>
    <van-cell :title="title" :icon="icon"
              @click="showCtn = !showCtn"
              is-link :arrow-direction="showCtn ? 'up' :'down'">
    </van-cell>
    <div v-show="showCtn" :class="ctnClass || 'pad-lft-20'">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      outerShow: Boolean,
      icon: String,
      title: String,
      ctnClass: String
    },
    data() {
      return {
        showCtn: false,
      }
    },
    watch: {
      outerShow() {
        this.showCtn = this.outerShow;
      },
    },
    created() {
      this.showCtn = this.outerShow;
    },
    methods: {}
  }
</script>

<style scoped>
</style>
